import Papa from 'papaparse';

export default class {
    /*@ngInject*/
    constructor($http) {
        this.$http = $http;
        this.file = null;
    }

    create(callback) {
        this.success = null;
        this.$http.post('/api/tutors', this.tutor).then(res => {
            this.tutor = {};
            callback();
        })
    }

    uploadFile = ($event) => {
        this.file = $event.target.files[0];
    }

    change($close) {
        Papa.parse(this.file, {
            header: true,
            dynamicTyping: true,
            complete: $close
        });
    }
}


// WEBPACK FOOTER //
// ./client/app/modals/deputy-import/controller.js